(() => {
  (() => {
    class t extends HTMLElement {
      currentVariant;
      form;
      swatch;
      input;
      prices;
      priceDiscount;
      specialDiscount;
      option0;
      option1;
      option2;
      option3;
      imageBar;
      stars;
      button;
      save_additional;
      affirmText;
      gallery;
      gallery2;
      nGallery;
      nVideo;
      image;
      select;
      noSelect;
      options;
      wrapper;
      afterPayPrice;
      additionalText;
      shopBarToggles;
      quantitySelector;
      constructor() {
        super(),
          (this.currentVariant = window.theme.product.currentVariant),
          (this.form = this.querySelector("form")),
          (this.swatch = this.querySelector("#variantPicker")),
          (this.save_additional = this.querySelector(
            ".discount-additional-text"
          )),
          (this.input = this.form.querySelector('input[name="id"]')),
          (this.prices = this.querySelectorAll(".product-price")),
          (this.priceDiscount = this.querySelectorAll(
            ".product-price-discount"
          )),
          (this.specialDiscount = this.querySelectorAll(
            ".special-discount-item"
          )),
          (this.imageBar = document.querySelector(".shop-bar_image")),
          (this.stars = this.querySelector("[data-oke-star-rating]")),
          (this.button = this.querySelector(".product-form__submit")),
          (this.affirmText = this.querySelector(".affirm-as-low-as")),
          (this.gallery = document.querySelector(
            "product-form .product-gallery"
          )),
          (this.gallery2 = document.querySelector(
            ".product-gallery-grid .product-gallery"
          )),
          (this.nGallery = document.querySelector(".product-gallery-grid")),
          (this.nVideo = document.querySelector(
            ".product-gallery-grid .product-gallery_item-video"
          )),
          (this.wrapper = document.querySelector(".product__info-wrapper")),
          (this.additionalText = document.querySelector(
            "#product-form_additional-text"
          )),
          (this.afterPayPrice = document.querySelector(".afterpay-price")),
          (this.productLabel = document.querySelector(
            "#best-seller-label-pdp"
          )),
          (this.submitting = !1),
          (this.shopBarToggles = this.querySelectorAll(".shop-bar-toggle")),
          (this.quantitySelector = this.querySelector(".quantity")),
          "Gift Card" === window.theme.product.type &&
            ((this.image = document.querySelector(
              "product-form .product-gallery img"
            )),
            (this.select = this.swatch.querySelector(
              ".blanket-options_select"
            )),
            (this.noSelect = !0),
            this.select.addEventListener(
              "click",
              this.handleSelect.bind(this)
            )),
          this.swatch &&
            ((this.option0 = this.swatch.querySelector(
              ".product_option0-value"
            )),
            (this.option1 = this.swatch.querySelector(
              ".product_option1-value"
            )),
            (this.option2 = this.swatch.querySelector(
              ".product_option2-value"
            )),
            (this.option3 = this.swatch.querySelector(
              ".product_option3-value"
            )),
            this.swatch.addEventListener(
              "change",
              this.onVariantChange.bind(this)
            ),
            (this.firstLoad = !0),
            this.onVariantChange(),
            this.showOnlyAvailableColors()),
          this.form.addEventListener("submit", this.handleForm.bind(this)),
          this.classList.contains("shop-bar-disabled") ||
            window.addEventListener("scroll", this.handleScroll.bind(this)),
          this.stars &&
            this.stars.addEventListener("click", () => {
              const t = document.querySelector(
                "[data-oke-carousel], [data-oke-widget]"
              );
              t &&
                window.scrollTo({ top: t.offsetTop - 70, behavior: "smooth" });
            }),
          this.handleLables(),
          this.handleSkuPrime();
      }
      showOnlyAvailableColors() {
        const t = this.swatch.querySelectorAll('input[name="Color"], input[name="Farbe"]');
        window.theme.hideUnavailableWeights &&
          t &&
          t.forEach((t) => {
            window.theme.product.variants.find(
              (e) => e.options[0] === t.value && e.available
            ) || t.nextElementSibling.setAttribute("hidden", "");
          });
      }
      handleSkuPrime() {
        let t = window.theme.product.skuPrime,
          e = !1;
        if (void 0 !== t)
          for (let i = 0; i < t.length; i++)
            t[i] == window.theme.product.currentVariant.sku && (e = !0);
      }
      updateBedsheetPillowCount() {
        const els = document.querySelectorAll("[data-bedsheet-pillow-count]");
        if (!els.length || !this.currentVariant?.options) return;

        const isSingle = this.currentVariant.options.some((option) =>
          String(option).toLowerCase().replace(/\s+/g, "").includes("135x200")
        );
        const isDe = window.location.pathname.includes("/de");
        const label = isSingle
          ? isDe
            ? "1 Kissenbezug"
            : "1 Pillow Case"
          : isDe
            ? "2 Kissenbezüge"
            : "2 Pillow Cases";

        els.forEach((el) => {
          el.textContent = label;
        });
      }
      syncBundleSheetQuantity() {
        // bundle-sheet only: hide included UI; 135 x 200 cm → 1, all other sizes → 2
        if (window.theme.product?.template !== "bundle-sheet" || !this.swatch)
          return;

        const qtyFieldset =
          this.swatch.querySelector(".swatch-included") ||
          this.swatch.querySelector(".swatch-pillow-case") ||
          this.swatch.querySelector(".swatch-quantity");
        if (!qtyFieldset) return;

        const sizeFieldset =
          this.swatch.querySelector(".swatch-duvet-set-size") ||
          this.swatch.querySelector(".swatch-size") ||
          this.swatch.querySelector(".swatch-große") ||
          this.swatch.querySelector(".swatch-grosse");
        const sizeVal =
          sizeFieldset?.querySelector("input:checked")?.value ||
          this.swatch.querySelector('[name="Duvet Set Size"]:checked')?.value ||
          this.swatch.querySelector('[name="Size"]:checked')?.value ||
          this.swatch.querySelector('[name="Größe"]:checked')?.value ||
          "";

        const isSingle = String(sizeVal)
          .toLowerCase()
          .replace(/\s+/g, "")
          .includes("135x200");
        const targetQty = isSingle ? "1" : "2";
        const targetInput = qtyFieldset.querySelector(
          `input[value="${targetQty}"]`
        );
        if (!targetInput || targetInput.checked) return;

        targetInput.checked = true;
        const qtyLabel = qtyFieldset.querySelector(
          '[class*="product_option"][class*="-value"]'
        );
        if (qtyLabel) qtyLabel.innerHTML = targetQty;
      }
      handleLables() {
        if ("Gift Card" === window.theme.product.type || !this.productLabel) return;
        const label = (this.currentVariant.variant_label || "").trim();
        const labelDown = label.toLowerCase();
        const isNewTag = labelDown === "new" || labelDown === "neu";
        this.productLabel.innerHTML = isNewTag ? "" : label;
        this.productLabel.style.background = isNewTag
          ? ""
          : this.currentVariant.variant_label_color || "";
        this.productLabel.classList.toggle("is-new-tag", isNewTag);
      }
      handleScroll() {
        const t = this.parentElement,
          e = this.classList.contains("shop-bar"),
          i = this.formVisible();
        i && e
          ? ("" !== t.style.minHeight && (t.style.minHeight = ""),
            this.classList.remove("shop-bar"))
          : i ||
            e ||
            ("" === t.style.minHeight &&
              (t.style.minHeight = t.offsetHeight + "px"),
            this.classList.add("shop-bar"));
      }
      formVisible() {
        let t = this.wrapper.offsetTop - 70,
          e = this.wrapper.offsetLeft,
          i = this.wrapper.offsetWidth,
          r = this.wrapper.offsetHeight;
        return (
          t < window.pageYOffset + window.innerHeight &&
          e < window.pageXOffset + window.innerWidth &&
          t + r > window.pageYOffset &&
          e + i > window.pageXOffset
        );
      }
      handleForm(t) {
        if ((t.preventDefault(), this.submitting)) return;
        this.submitting = !0;
        const e = this.querySelector('[type="submit"]');
        e && (e.setAttribute("disabled", "true"), e.classList.add("loading"));

        if (window.theme.product.template == "biscuit-bundle") {
          const formData = new FormData(this.form);
          fetch("/cart/add", { ...window.theme.fetchConfig(), body: formData })
            // fetch("/cart/add", { ...window.theme.fetchConfig(), body: i })
            .then((t) => {
              window.theme.cart.render(t, !0); // Pass the response to the render function
            })
            .catch((e) => {
              console.error("CART ERROR: ", e), t.target.submit();
            })
            .finally(() => {
              (this.submitting = !1),
                e &&
                  (e.classList.remove("loading"),
                  e.removeAttribute("disabled"));
              const t = document.querySelector(".close");
              t && t.click();
            });
        } else {
          const i = JSON.stringify({
            ...JSON.parse(window.theme.utils.serializeForm(this.form)),
          });
          fetch("/cart/add", { ...window.theme.fetchConfig(), body: i })
            .then((t) => t.json())
            .then((t) => {
              window.theme.cart.render(!0);
            })
            .catch((e) => {
              console.error("CART ERROR: ", e), t.target.submit();
            })
            .finally(() => {
              (this.submitting = !1),
                e &&
                  (e.classList.remove("loading"),
                  e.removeAttribute("disabled"));
              const t = document.querySelector(".close");
              t && t.click();
            });
        }
      }
      onVariantChange() {
        this.syncBundleSheetQuantity(),
          this.updateOptions(),
          this.updateMasterId(),
          this.updateMedia(),
          this.checkAvailability(),
          this.updateURL(),
          this.updateVariantInput(),
          (window.theme.product.currentVariant = this.currentVariant),
          this.changeElements(),
          this.updateBedsheetPillowCount(),
          this.handleLables(),
          this.handleSkuPrime(),
          this.handleLpColors(),
          this.updateAfterpay(),
          this.currentVariant.options.forEach((t, e) => {
            this.setAttribute(`data-option${e + 1}`, t);
          }),
          40597836693690 === this.currentVariant.id
            ? this.button.classList.add("hidden")
            : this.button.classList.remove("hidden"),
          "product" in this.currentVariant &&
            (window.theme.product.title = this.currentVariant.product),
          this.updateAffirm(),
          this.noSelect &&
            !this.select.hasAttribute("open") &&
            (this.select.setAttribute("selected", ""), (this.noSelect = !1));
      }
      updateAfterpay() {
        // if (document.querySelector("afterpay-placement")) {
        //     const t = document.querySelector(".product-price-compare")
        //     ? document.querySelector(".product-price-compare").textContent
        //     : this.currentVariant.price;
        //     const i = document.querySelector("afterpay-placement");
        //     if (null !== i.shadowRoot) {
        //       const r = i.shadowRoot.querySelector(".afterpay-main-text"),
        //         o = r.textContent;
        //         o.includes(t) || (r.textContent = t + " " + o);
        //     }
        // }

        //update the data attribute data-mobile-price for the element .afterpay-price based on the current product price

        if (this.afterPayPrice) {
          const t = this.currentVariant.price;
          this.afterPayPrice.dataset.mobilePrice = t;
        }
      }
      updateAffirm() {
        if (
          this.affirmText &&
          "undefined" != typeof affirm &&
          affirm.jsReady()
        ) {
          const t = this.currentVariant.price.replace("€", "") + "00";
          this.affirmText.setAttribute("data-amount", t), affirm.ui.refresh();
        }
      }
      updateOptions() {
        const t = Array.from(this.swatch.querySelectorAll("fieldset"));
        (this.options = t.map((t) => {
          const e = Array.from(t.querySelectorAll("input")).find(
            (t) => t.checked
          );
          return !!e && e.value;
        })),
          window.theme.product.landing && this.options.shift();
      }
      updateMasterId() {
        const t = window.theme.hideUnavailableWeights,
          e = this.currentVariant.sizes.join(",");
        if (
          ((this.currentVariant = window.theme.product.variants.find(
            (t) => !t.options.map((t, e) => this.options[e] === t).includes(!1)
          )),
          this.currentVariant ||
            (this.currentVariant = window.theme.product.variants.find(
              (t) => t.options[0] === this.options[0]
            )),
          t &&
            "Color" === window.theme.product.options[0] &&
            "Weight (lbs)" === window.theme.product.options[1])
        ) {
          this.setAttribute("data-hide-weights", "true");
          const t = this.querySelectorAll(
            'input[name="' + window.theme.product.options[1] + '"]'
          );
          if (0 === t.length) return;
          for (var i = 0; i < t.length; i++) {
            var r = t[i];
            const e = r.value;
            var o = r.nextElementSibling;
            window.theme.product.variants.find(
              function (t) {
                return (
                  t.options[1] === e &&
                  t.options[0] === this.currentVariant?.options?.[0] &&
                  t.available
                );
              }.bind(this)
            )
              ? o.removeAttribute("hidden")
              : o.setAttribute("hidden", "");
          }
          const e = this.querySelector(
            'input[name="' +
              window.theme.product.options[1] +
              '"] + label:not([hidden])'
          );
          !this.currentVariant?.available && e && e.click();
        } else if (this.currentVariant.sizes.join(",") !== e) {
          this.querySelector(
            'input[value="' + this.currentVariant.options[1] + '"]'
          ).click(),
            (this.options = this.currentVariant.options);
          let t = this.querySelectorAll(
            'input[name="' + window.theme.product.options[1] + '"]'
          );
          if (0 === t.length) return;
          for (let e = 0; e < t.length; e++) {
            const i = t[e],
              r = i.nextElementSibling;
            this.currentVariant.sizes.includes(i.value)
              ? r.removeAttribute("hidden")
              : r.setAttribute("hidden", "");
          }
        }
      }
 updateMedia() {
  // alert('Hi');
  if ("Sleeper" !== window.theme.product.title) {
// alert(window.theme.product.type);
    if ("Gift Card" === window.theme.product.type) {
      const t = window.theme.product.images[this.currentVariant.color][1];
      this.image.src = t.src;
      this.image.alt = t.alt;
      this.updateGallery(window.theme.product.images[this.currentVariant.color]);
    } else {

      const isOceanNapper =
        window.location.pathname.includes('ocean-napper') ||
        (window.theme.product && window.theme.product.handle === 'ocean-napper');

      const isHuggerSelected =
        isOceanNapper &&
        this.currentVariant.options &&
        (this.currentVariant.options.includes('Queen 20') ||
         this.currentVariant.options.includes('King 25'));

      const isBodyPillow =
        window.location.pathname.includes('body-pillow') ||  window.location.pathname.includes('korperkissen') ||
        (window.theme.product && window.theme.product.handle === 'body-pillow') || (window.theme.product && window.theme.product.handle === 'korperkissen') || (window.theme.product && window.theme.product.handle === 'body-pillow-new') || (window.theme.product && window.theme.product.handle === 'body-pillow-cover');
     

      let t;

      // =============================
      //  BODY PILLOW (STRICT FIX)
      // =============================
if (isBodyPillow) {
    //  alert(isBodyPillow);
// alert('hi');
  let color = '';
  let size = '';
  let material = '';
  this.currentVariant.options.forEach(opt => {
    const val = opt.toLowerCase();

    if (val.includes('medium')) size = 'medium';
   else if (val.includes('large')) size = 'large';
    else if (val.includes('linen')) material = 'linen';
    else if (val.includes('cotton')) material = 'cotton';
    else color = val.replace(/\s+/g, '-');
  });


  let allImages = [];

  if (window.theme.product.landing) {
    allImages = Object.values(window.theme.product.images[this.currentVariant.product] || {}).flat();
  } else {
    allImages = Object.values(window.theme.product.images || {}).flat();
  }

  const sizeRegex = new RegExp(`_${size}([_\\.])`);

  // FILTER → color + size + material
  t = allImages.filter(img => {
    const src = img.src.toLowerCase();

    return (
      src.includes(color) &&
      sizeRegex.test(src) &&
      (material ? src.includes(material) : true)
    );
  });

  // fallback 1 → color + size
  if (!t || t.length === 0) {
    t = allImages.filter(img => {
      const src = img.src.toLowerCase();
      return src.includes(color) && sizeRegex.test(src);
    });
  }

  // fallback 2 → only color
  if (!t || t.length === 0) {
    t = allImages.filter(img => {
      return img.src.toLowerCase().includes(color);
    });
  }

  // =============================
  // IMPORTANT FIX (MODAL + VIDEO SYNC)
  // =============================

  // store filtered images TEMPORARILY (not globally)
  this._filteredImages = t;

  console.log('BODY PILLOW FINAL:', t.map(i => i.src));
}
      // =============================
      //  OTHER PRODUCTS (UNCHANGED)
      // =============================
      if (isBodyPillow && t && t.length) {
        // do nothing
      }
      else if (isHuggerSelected) {

        const huggerColorKey = 'hugger-' + this.currentVariant.color;

        t = window.theme.product.landing
          ? window.theme.product.images[this.currentVariant.product][huggerColorKey]
          : window.theme.product.images[huggerColorKey];

        if (!t) {
          t = window.theme.product.landing
            ? window.theme.product.images[this.currentVariant.product][this.currentVariant.color]
            : window.theme.product.images[this.currentVariant.color];
        }

      }
      else {

        t = window.theme.product.landing
          ? window.theme.product.images[this.currentVariant.product][this.currentVariant.color]
          : window.theme.product.images[this.currentVariant.color];

      }

      // Filenames like Muslin_Throw-Midnight-Blue-2n.jpg are not keyed by the leading "Muslin_"
      if ((!t || !t.length) && this.currentVariant && this.currentVariant.color) {
        const colorKey = String(this.currentVariant.color).toLowerCase();
        const allImages = window.theme.product.landing
          ? Object.values(window.theme.product.images[this.currentVariant.product] || {}).flat()
          : Object.values(window.theme.product.images || {}).flat();
        t = allImages.filter((img) =>
          String(img.src || "")
            .toLowerCase()
            .replace(/_/g, "-")
            .includes(colorKey)
        );
      }

      // =============================
      //  UPDATE GALLERY
      // =============================
      if (t && t.length) {
        if (this.gallery && this.gallery.update) {
          this.gallery.update(t, window.theme.product.video);
        }

        if (this.gallery2 && this.gallery2.update) {
          this.gallery2.update(t, window.theme.product.video);
        }

        this.updateGallery(t);
      }
    }

    this.imageBar.src = this.currentVariant.image;

    if (window.theme.product.videoObserverInit) {
      window.theme.product.videoObserverInit();
    }
  }
}  
    updateGallery(t) {
        if ("true" === this.nGallery.dataset.slider || 0 === t.length) return;
        let e = "";
        t.forEach(function (t, i) {
          e += `\n      <div class="product-gallery_item product-gallery_item-image pointer">  \n        <div class="media media--square">\n          <img src="${t.src}" alt="${t.alt}" width="800" height="1000" class="cover-image" loading="lazy" onclick="window.theme.product.modal(${i})">\n        </div>\n      </div>`;
        }),
          window.theme.product.video
            ? (e += `\n    <div class="product-gallery_item product-gallery_item-video pointer">  \n      <div class="media media--square">\n        <video playsinline autoplay loop muted class="cover-image" poster="${window.theme.product.video.image}" onclick="window.theme.product.modal(${t.length})">\n          <source src="${window.theme.product.video.src}" type="video/mp4">\n          Your browser does not support the video tag.\n        </video> \n      </div>\n    </div>`)
            : window.theme.product.videos &&
              window.theme.product.videos[this.currentVariant.product] &&
              (e += `\n    <div class="product-gallery_item product-gallery_item-video pointer">  \n      <div class="media media--square">\n        <video playsinline autoplay loop muted class="cover-image" poster="${
                window.theme.product.videos[this.currentVariant.product].image
              }" onclick="window.theme.product.modal(${
                t.length
              })">\n          <source src="${
                window.theme.product.videos[this.currentVariant.product].src
              }" type="video/mp4">\n          Your browser does not support the video tag.\n        </video> \n      </div>\n    </div>`),
          (this.nGallery.innerHTML = e);
      } 
      updateURL() {
        if (window.theme.product.landing) return;
        if (this.firstLoad) return void (this.firstLoad = !1);
        const t = new URLSearchParams(window.location.search);
        t.set("variant", this.currentVariant.id);
        const e = window.location.pathname + "?" + t.toString();
        history.pushState(null, "", e);
      }
      updateVariantInput() {
        (this.input.value = this.currentVariant.id),
          this.input.dispatchEvent(new Event("change", { bubbles: !0 }));
      }
      checkAvailability() {
        this.currentVariant.available
          ? this.removeAttribute("soldout")
          : this.setAttribute("soldout", "");
      }
      
      changeElements() {
      
        if (window.theme.product.currentVariant.is_preoder === "true") {
          document.querySelector("#product-form_preorder-text").style.display =
            "block";

          let preorderText = window.theme.product.currentVariant.preorder_text;

          if (window.location.pathname.includes("/de")) {
            preorderText = preorderText
              .replace("Ships by the week of", "Wird versendet in der Woche ab")
              .replace(/(\d+)(th|nd|st|rd)/g, "$1")
              .replace("January", "Januar")
              .replace("February", "Februar")
              .replace("March", "März")
              .replace("April", "April")
              .replace("May", "Mai")
              .replace("June", "Juni")
              .replace("July", "Juli")
              .replace("August", "August")
              .replace("September", "September")
              .replace("October", "Oktober")
              .replace("November", "November")
              .replace("December", "Dezember");

            this.button.innerHTML = "VORBESTELLEN";
          } else {
            this.button.innerHTML = "PRE-ORDER";
          }

          document.querySelector("#product-form_preorder-text").innerHTML =
            preorderText;
        } else {
          if (window.location.pathname.includes("/de")) {
            this.button.innerHTML = "IN DEN WARENKORB";
          } else {
            this.button.innerHTML = "ADD TO CART";
          }
          document.querySelector("#product-form_preorder-text").style.display =
            "none";
        }

        const t = document.querySelectorAll(
            ".product-price-compare.compare-price"
          ),
          e = document.querySelectorAll(".tag--save"),
          i = document.querySelectorAll(".compare-price-cart.product-price");
        let r = this.currentVariant.price,
          o = parseFloat(r.replace("€", ""));
        var n = 0;
        if (
          ((o = o.toFixed(0)),
          t.forEach((t) => {
            let r = !1;
            this.specialDiscount.forEach((o) => {
              if (o.innerHTML == window.theme.product.currentVariant.id)
                return (
                  (n = 1 - o.dataset.specialDiscount / 100),
                  t.classList.add("red"),
                  (document.querySelector(
                    ".discount-additional-text-wrapper"
                  ).style.display = "block"),
                  (this.save_additional.style.display = "inline-block"),
                  (i[0].style.display = "block"),
                  e.forEach((t) => {
                    (t.dataset.textDiscount =
                      o.dataset.specialDiscount + (window.location.pathname.includes("/de") || document.documentElement.lang === "de" ? "% Rabatt" : "% off")),
                      (t.style.display = "flex");
                    if (window.location.pathname.includes("/de") || document.documentElement.lang === "de") {
                      this.save_additional.innerHTML =
                        "Spare " + o.dataset.specialDiscount + "% ";
                    } else {
                      this.save_additional.innerHTML =
                        "Save " + o.dataset.specialDiscount + "% ";
                    }
                  }),
                  void (r = !0)
                );
            }),
              r ||
                ((n = 1 - t.dataset.discount / 100),
                t.classList.add("red"),
                (document.querySelector(
                  ".discount-additional-text-wrapper"
                ).style.display = "block"),
                (this.save_additional.style.display = "inline-block"),
                (i[0].style.display = "block"),
                (this.save_additional.innerHTML =
                  (window.location.pathname.includes("/de") || document.documentElement.lang === "de" ? "Spare " : "Save ") + t.dataset.discount + "% "),
                e.forEach((e) => {
                  (e.dataset.textDiscount = t.dataset.discount + (window.location.pathname.includes("/de") || document.documentElement.lang === "de" ? "% Rabatt" : "% off")),
                    (e.style.display = "flex");
                })),
              (t.innerHTML = `${Math.round(o * n)}` + " €"),
              (this.button.dataset.mobilePrice = `${Math.round(o * n)}` + " €");
          }),
          this.prices.forEach((t) => {
            t.innerHTML = this.currentVariant.price;
          }),
          this.priceDiscount.forEach((t) => {
            let e = parseFloat(
                this.currentVariant.price.replace(/[^0-9.-]+/g, "")
              ),
              i = Math.ceil(1.11 * e);
            t.innerHTML = "€" + i.toFixed(0);
          }),
          (this.button.dataset.bundlePrice = this.currentVariant.price),
          (this.button.dataset.unitPrice = this.currentVariant.price))
        );
        const currentPath = window.location.pathname;

        // const colorTranslations = {
        //   "Midnight Blue": "Nachtmarine",
        //   "Moonstone Grey": "Mondstein-Grau",
        //   "Asteroid Grey": "Nachtruhe-Grau",
        //   "Driftwood": "Sandelholz",
        //   "Sweet Lavender": "Süßlavendel",
        //   "Holliberry": "Burgunderrot",
        //   "Hollyberry": "Burgunderrot",
        //   "Moonbeam": "Mondschein",
        //   "Seashell": "Sonnenkoralle",
        //   "Starry Night": "Sternennacht",
        //   "Evening Rose": "Wildrose",
        //   "Confetti": "Konfetti",
        //   "Morning Matcha": "Matcha",
        //   "Blue Spruce": "Salbeiblüte",
        //   "Base Cover (White)": "Basis-Bezug, weiß",
        //   "Base Cover (White)": "Basis-Bezug, weiß",
        //   "Bluebell": "Glockenblume",
        //   "Twilight Sky": "Morgendämmerung",
        //   "Pebble Grey": "Nebelstein",
        //   "Sage": "Salbei"
        // };
        // if (this.option1) {
        //   this.option1.innerHTML = this.currentVariant.options[0];
        //   // if (window.location.pathname.includes("/de")) {
        //   //   const englishColor = this.currentVariant.options[0];
        //   //   if (colorTranslations[englishColor]) {
        //   //     this.option1.innerHTML = colorTranslations[englishColor];
        //   //   }
        //   // }
  if (this.option1) {
  const isGerman = window.location.pathname.includes('/de');

  if (window.theme.product.options[0] === "Size" && window.theme.product.title === "Sleeper") {
    this.option1.innerHTML = this.currentVariant.options[0] + window.theme.getDimension(this.currentVariant.options[0]);
  } else if (!isGerman) {
    this.option1.innerHTML = this.currentVariant.options[0];
  } else {
    const path = window.location.pathname;
    const handle = window.theme.product?.handle || '';
    const isBodyPillowCover =
      handle === 'korperkissen-bezug' ||
      handle === 'body-pillow-cover' ||
      path.includes('korperkissen-bezug') ||
      path.includes('body-pillow-cover');
    const isBodyPillow =
      path.includes('body-pillow') || path.includes('korperkissen');
    // Body pillow PDP has its own DE flow; cover must still translate color on change
    if (isBodyPillow && !isBodyPillowCover) return;

    function getTranslations() {
      try {
        return typeof window.colorTranslations === 'string'
          ? JSON.parse(window.colorTranslations)
          : (window.colorTranslations || {});
      } catch(e) { return {}; }
    }

    const translations = getTranslations();
    const englishColor = this.currentVariant.options[0];
    const option0Name = (window.theme.product.options[0] || '').toLowerCase();
    const isBundleSheet = window.theme.product.template === 'bundle-sheet';

    // bundle-sheet only: size-first option1 is size, not color
    if (isBundleSheet && (option0Name.includes('size') || option0Name.includes('größe') || option0Name.includes('grosse'))) {
      this.option1.innerHTML = englishColor;
    } else {
      this.option1.innerHTML = translations[englishColor] || englishColor;
    }
  }
}
        if (
          window.theme.product.options[1] &&
          (window.theme.product.options[1].includes("Weight") ||
            window.theme.product.options[1].includes("Gewicht"))
        ) {
          if (this.option2)
            this.option2.innerHTML =
              this.currentVariant.options[1]
                .replace("Queen ", "")
                .replace("King ", "") +
              " kg " +
              window.theme.getDimension(this.currentVariant.options[1]);
        } else if (
          window.theme.product.options[0] === "Size" &&
          window.theme.product.title === "Sleeper"
        ) {
          if (this.option1)
            this.option1.innerHTML =
              this.currentVariant.options[0] +
              window.theme.getDimension(this.currentVariant.options[0]);
        } else if (
          window.theme.product.options[1] &&
          window.theme.product.options[1] === "Size" &&
          window.theme.product.type !== "Gift Card"
        ) {
          let option = this.currentVariant.options[1];
          if (option === "Small" && window.theme.product.title === "Pupper Pod")
            option = "Small1";
          else if (
            option === "Medium" &&
            window.theme.product.title === "Pupper Pod"
          )
            option = "Medium1";
          if (this.option2)
            this.option2.innerHTML =
              this.currentVariant.options[1] +
              window.theme.getDimension(option);
        } else if (this.option2) {
          const optionName = window.theme.product.options[1];
          const value = this.currentVariant.options[1];
          const isGerman = window.location.pathname.includes('/de');

          if (optionName && optionName.includes("Material")) {
            if (isGerman) {
              if (value === 'Cotton') this.option2.innerHTML = 'Bio-Baumwolle';
              else if (value === 'Linen') this.option2.innerHTML = 'Leinen';
              else if (value === 'Base') this.option2.innerHTML = 'Basis';
              else this.option2.innerHTML = value;
            } else {
              this.option2.innerHTML = value;
            }
          } else if (
            isGerman &&
            optionName &&
            (optionName.includes("Color") || optionName.includes("Cover"))
          ) {
            let translations = {};
            try {
              translations =
                typeof window.colorTranslations === "string"
                  ? JSON.parse(window.colorTranslations)
                  : window.colorTranslations || {};
            } catch (e) {}
            if (value === "Included" || value === "Base Included") {
              this.option2.innerHTML =
                translations[value] ||
                translations["Base Included"] ||
                "Inbegriffen";
            } else if (value === "No Cover") {
              this.option2.innerHTML =
                translations[value] || "Weiß (Basis)";
            } else {
              this.option2.innerHTML = translations[value] || value;
            }
          } else {
            this.option2.innerHTML = value;
          }
        }
        this.updateColorOptionLabel();
      }
      updateColorOptionLabel() {
        // bundle-sheet template only
        if (window.theme.product?.template !== 'bundle-sheet') return;
        if (!this.swatch || !this.currentVariant || !window.theme.product?.options) return;

        const options = window.theme.product.options;
        const colorIndex = options.findIndex((name) => {
          const n = String(name || '').trim().toLowerCase();
          return n === 'color' || n === 'farbe';
        });
        if (colorIndex < 1) return;

        const colorValue = this.currentVariant.options[colorIndex];
        if (!colorValue) return;

        const colorLabel = this.swatch.querySelector(
          '.swatch-color [class*="product_option"][class*="-value"]'
        );
        if (!colorLabel) return;

        const isGerman = window.location.pathname.includes('/de');
        let display = colorValue;

        if (isGerman) {
          let translations = {};
          try {
            translations =
              typeof window.colorTranslations === 'string'
                ? JSON.parse(window.colorTranslations)
                : window.colorTranslations || {};
          } catch (e) {
            translations = {};
          }
          const fallback = {
            'Cloud White': 'Wolkenweiß',
            'Morning Pearl': 'Morgenperle',
            'Sweet Lavender': 'Süßlavendel',
            'Moonstone Grey': 'Mondstein-Grau',
            'Asteroid Grey': 'Nachtruhe-Grau',
            'Driftwood': 'Sandelholz',
            'Blue Spruce': 'Salbeiblüte',
            'Morning Matcha': 'Matcha',
            'Midnight Blue': 'Nachtmarine',
            'Bluebell': 'Glockenblume',
            'Twilight Sky': 'Morgendämmerung',
            'Seashell': 'Sonnenkoralle',
            'Starry Night': 'Sternennacht',
            'Evening Rose': 'Wildrose',
          };
          display = translations[colorValue] || fallback[colorValue] || colorValue;
        }

        colorLabel.innerHTML = display;
      }
      handleSelect(t) {
        "INPUT" !== t.target.tagName &&
          (this.select.hasAttribute("open")
            ? this.select.removeAttribute("open")
            : this.select.setAttribute("open", ""));
      }
      handleLpColors() {
        const t = this.querySelector('[name="Type"]:checked');
        "weight-lp" === this.dataset.type &&
          t &&
          (this.querySelectorAll(".swatch-color label:not([hidden])").forEach(
            (e) => {
              e.dataset.product === t.value
                ? e.classList.remove("d-none")
                : e.classList.add("d-none");
            }
          ),
          this.querySelector('[name="Color"]:checked + label.d-none') &&
            this.querySelector(
              '[name="Color"] + label:not(.d-none):not([hidden])'
            ).click());
      }
    }
    customElements.define("product-form", t),
      (function () {
        var t = document.querySelector("#product-zoom-modal");
        if (t) {
          const r = t.querySelector("img"),
            o = t.querySelector("video"),
            n = t.querySelector(".slider-next"),
            s = t.querySelector(".slider-prev");
          function e(t) {
            let e,
              i = parseInt(r.dataset.index);
            e = window.theme.product.landing
              ? window.theme.product.images[
                  window.theme.product.currentVariant.product
                ][window.theme.product.currentVariant.color]
              : "Sleeper" === window.theme.product.title
              ? window.theme.product.images.sleeper
              : window.theme.product.images[
                  window.theme.product.currentVariant.color
                ];
            const n = e.length - 1;
            if (o && (("next" === t && i === n) || ("prev" === t && 0 === i))) {
              o.removeAttribute("hidden");
              const t = o.play();
              return (
                void 0 !== t &&
                  t.catch(function (t) {
                    console.log("error: ", t);
                  }),
                void (r.dataset.index = e.length.toString())
              );
            }
            "next" === t
              ? i >= n
                ? (i = 0)
                : i++
              : "prev" === t && (0 === i ? (i = n) : i--),
              (r.src = ""),
              o && !o.paused && (o.pause(), o.setAttribute("hidden", "")),
              (r.src = e[i].src),
              (r.dataset.index = i.toString());
          }
          (window.theme.product.modal = function (e) {
            let i;
            if (
              ((i = window.theme.product.landing
                ? window.theme.product.images[this.currentVariant.product][
                    this.currentVariant.color
                  ]
                : "Sleeper" === window.theme.product.title
                ? window.theme.product.images.sleeper
                : window.theme.product.images[this.currentVariant.color]),
              i)
            ) {
              if (e === i.length) {
                o.removeAttribute("hidden");
                const t = o.play();
                void 0 !== t &&
                  t.catch(function (t) {
                    console.log("error: ", t);
                  });
              } else {
                (r.src = ""),
                  o && !o.paused && (o.pause(), o.setAttribute("hidden", ""));
                const t = i[e];
                r.src = t.src.replace("_800x", "");
              }
              (r.dataset.index = e.toString()),
                document.body.classList.add("body_fade"),
                document.body.classList.add("header_fade"),
                t.setAttribute("open", "");
            }
          }),
            n.addEventListener("click", function () {
              e("next");
            }),
            s.addEventListener("click", function () {
              e("prev");
            });
        }
        const i = new IntersectionObserver(
          (t) => {
            t.forEach((t) => {
              const e = t.target;
              if (t.isIntersecting) {
                const t = e.play();
                void 0 !== t &&
                  t.catch(function (t) {
                    console.log("error: ", t);
                  });
              } else e.pause();
            });
          },
          { threshold: 0.2 }
        );
        document.querySelectorAll(".product-gallery video").forEach((t) => {
          i.observe(t);
        });
      })();
  })();
  const t = document.querySelectorAll("[data-tab-target]"),
    e = document.querySelectorAll("[data-tab-content]");
  t.forEach((i) => {
    i.addEventListener("click", () => {
      const r = document.querySelector(i.dataset.tabTarget);
      e.forEach((t) => {
        t.classList.remove("active");
      }),
        t.forEach((t) => {
          t.classList.remove("active");
        }),
        i.classList.add("active"),
        r.classList.add("active");
    });
  });
  class i extends HTMLElement {
    constructor() {
      super(),
        (this.originalHTML = this.innerHTML),
        (this.originalTextContent = this.textContent);
    }
    static get observedAttributes() {
      return ["limit", "open"];
    }
    get less() {
      return this.getAttribute("less");
    }
    get more() {
      return this.getAttribute("more");
    }
    get limit() {
      return this.hasAttribute("limit")
        ? Number(this.getAttribute("limit"))
        : 10;
    }
    get isOpen() {
      return this.hasAttribute("open");
    }
    attributeChangedCallback(t, e, i) {
      this.render();
    }
    render() {
      this.textContent.length > this.limit &&
        (this.isOpen
          ? ((this.innerHTML = this.originalHTML),
            (this.querySelector("p:last-child").innerHTML = `\n          ${
              this.querySelector("p:last-child").innerHTML
            }\n          <button type="button">${
              this.less
            }</button>\n        `))
          : (this.innerHTML = `\n          <p>\n            ${this.originalTextContent
              .trim()
              .slice(
                0,
                this.limit
              )}&hellip;\n            <button type="button">${
              this.more
            }</button>\n          </p>\n        `),
        this.querySelector("button")?.addEventListener(
          "click",
          this.toggle.bind(this)
        ));
    }
    toggle(t) {
      this.toggleAttribute("open");
    }
  }
  customElements.define("read-more", i);
})();
